import Dispatch from '../core/Dispatch';
import { COMPONENT_INIT } from '../lib/events';
import { loadFlatpickr } from '../lib/async-bundles';

export default (el, props = {}) => {

    const input = el.querySelector('input');

    const options = props.options || {};

    let Flatpickr;
    let picker;

    const initPicker = () => {
        if (!Flatpickr) {
            return;
        }

        picker = Flatpickr(input, options);
        input._datepicker = picker;
    };

    const init = () => {
        loadFlatpickr(({ default: flatpickr }) => {
            Flatpickr = flatpickr;
            initPicker();
        });

        Dispatch.emit(COMPONENT_INIT);
    };

    const destroy = () => {
        if (picker) {
            picker.close();
            picker.destroy();
            picker = null;
        }
        el._datepicker = null;
    };

    return {
        init,
        destroy
    };

};
